import React from 'react';

/**
 * The Zeme bracket mark on its own (no wordmark), in the brand gradient.
 * Gradient ids are namespaced so this can render alongside zemeBetaLogo
 * without the two clobbering each other's <defs>.
 *
 * @param {boolean} monochrome - Fill from currentColor instead of the brand
 * gradient, for use on an already-colored surface.
 */
function ZemeMark({
  monochrome = false,
  ...props
}: React.SVGProps<SVGSVGElement> & { monochrome?: boolean }) {
  const topFill = monochrome ? 'currentColor' : 'url(#zemeMarkTop)';
  const bottomFill = monochrome ? 'currentColor' : 'url(#zemeMarkBottom)';

  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(-0.1 -3.5)">
        <path
          d="M16.5713 4H3.95326C2.9496 4 2.13281 4.82563 2.13281 5.84014V9.32088C2.13281 9.76263 2.48696 10.1221 2.92549 10.1221C3.36403 10.1221 3.71817 9.76416 3.71817 9.32088V5.84014C3.71817 5.70914 3.82366 5.60099 3.95477 5.60099H16.5729C16.7025 5.60099 16.8095 5.70762 16.8095 5.84014V8.85323C16.8095 8.92177 16.7808 8.98728 16.7296 9.03298L11.0663 14.0918C10.7393 14.3843 10.7076 14.8901 10.997 15.2221C11.1537 15.4019 11.3722 15.4918 11.5907 15.4918C11.7776 15.4918 11.9645 15.4263 12.1152 15.2907L17.7785 10.2318C18.1688 9.88298 18.3933 9.38029 18.3933 8.85323V5.84014C18.3933 4.82563 17.5765 4 16.5729 4H16.5713Z"
          fill={topFill}
        />
        <path
          d="M17.5999 14.252C17.1628 14.252 16.8072 14.61 16.8072 15.0533V19.1601C16.8072 19.2911 16.7017 19.3992 16.5706 19.3992H3.84248C3.71288 19.3992 3.60588 19.2926 3.60588 19.1601V15.3732C3.60588 15.3183 3.62698 15.2665 3.66164 15.2239L4.22525 14.6481L8.0681 10.7637C8.16002 10.6707 8.30922 10.6707 8.40265 10.7637L9.43946 11.8117C9.7484 12.124 10.2502 12.124 10.5592 11.8117C10.8681 11.4994 10.8681 10.9922 10.5592 10.6799L9.52235 9.63185C8.81255 8.91438 7.65819 8.91438 6.9484 9.63185L2.5555 14.0723C2.53139 14.0966 2.50879 14.1241 2.48618 14.15L0.228699 16.4578C-0.0787282 16.7716 -0.0757142 17.2788 0.234727 17.5896C0.388441 17.7434 0.590378 17.8211 0.790809 17.8211C0.99124 17.8211 1.19921 17.7419 1.35443 17.5835L2.02052 16.901V19.1601C2.02052 20.1746 2.83731 21.0002 3.84097 21.0002H16.5706C17.5742 21.0002 18.391 20.1746 18.391 19.1601V15.0533C18.391 14.6115 18.0369 14.252 17.5983 14.252H17.5999Z"
          fill={bottomFill}
        />
      </g>
      <defs>
        <linearGradient
          id="zemeMarkTop"
          x1="10.028"
          y1="2.27258"
          x2="10.8055"
          y2="19.4897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F71FF8" />
          <stop offset="1" stopColor="#00B7FF" />
        </linearGradient>
        <linearGradient
          id="zemeMarkBottom"
          x1="13.6666"
          y1="22.2752"
          x2="4.69527"
          y2="10.0237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#006CFF" />
          <stop offset="1" stopColor="#00B7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ZemeMark;
